var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.5129L21 10.5129L21 10.4714L12 10.4714L12 14.4714L17.6515 14.4714C16.827 16.7999 14.6115 18.4714 12 18.4714C8.6865 18.4714 6 15.7849 6 12.4714C6 9.15794 8.6865 6.47144 12 6.47144C13.5295 6.47144 14.921 7.04844 15.9805 7.99094L18.809 5.16244C17.023 3.49794 14.634 2.47144 12 2.47144C6.4775 2.47144 2 6.94894 2 12.4714C2 17.9939 6.4775 22.4714 12 22.4714C17.5225 22.4714 22 17.9939 22 12.4714C22 11.8009 21.931 11.1464 21.8055 10.5129Z",
    fill: "#FBC02D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15234 7.81694L6.43784 10.2264C7.32684 8.02544 9.47984 6.47144 11.9993 6.47144C13.5288 6.47144 14.9203 7.04844 15.9798 7.99094L18.8083 5.16244C17.0223 3.49794 14.6333 2.47144 11.9993 2.47144C8.15834 2.47144 4.82734 4.63994 3.15234 7.81694Z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 22.4715C14.5832 22.4715 16.9302 21.483 18.7047 19.8755L15.6097 17.2565C14.6057 18.017 13.3577 18.4715 12.0002 18.4715C9.39916 18.4715 7.19066 16.813 6.35866 14.4985L3.09766 17.011C4.75266 20.2495 8.11366 22.4715 12.0002 22.4715Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.5129L21.7975 10.4714L21 10.4714L12 10.4714L12 14.4714L17.6515 14.4714C17.2555 15.5899 16.536 16.5544 15.608 17.2569C15.6085 17.2564 15.609 17.2564 15.6095 17.2559L18.7045 19.8749C18.4855 20.0739 22 17.4714 22 12.4714C22 11.8009 21.931 11.1464 21.8055 10.5129Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.2bd5f2b30d25b119e1a5f68cede61853.svg";
export { ForwardRef as ReactComponent };